import type { NextPage, GetStaticPropsContext } from 'next'
import { useTranslations } from 'next-intl'
import { Box } from '@chakra-ui/react'
import { MarkdownLoader } from '@/components/MarkdownLoader'
import SeoHead from '@/components/seo-head'

const RefundsAgreementPage: NextPage = () => {
  const t = useTranslations()
  return (
    <>
      <SeoHead
        title={t('agreements.seo.title', {
          agreementName: t('agreements.refund'),
        })}
        breadcrumbTitle={t('agreements.seo.breadcrumb', {
          agreementName: t('agreements.refund'),
        })}
        description={t('agreements.seo.description', {
          agreementName: t('agreements.refund'),
        })}
      />
      <Box py={12}>
        <MarkdownLoader mdFile={`refund-agreement.md`} />
      </Box>
    </>
  )
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      messages: (await import(`../../locales/${locale}.json`)).default,
    },
  }
}

export default RefundsAgreementPage
